/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import OriginModal from 'bee-modal';
import { getSysFieldid, PubSub, getParentWindow, getTopWindow } from '@platform/api';
import { getSafeRandom } from '@platform/api'
import classnames from 'classnames';
import MaxZoomBtn from '../MaxZoomBtn';

require('bee-modal/build/Modal.css');
require('./index.less');

let typeMap = { junior: true, senior: true, combine: true, max: true }

let indexArr = {};
class Modal extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        // this.getDomTimer = null;
        this.state = {
            initModalBodyHeight: '',
        };
    }

    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);
        // this.getDomTimer && clearTimeout(this.getDomTimer); 
        // 没有在modal里subscribe但是却做了unsubscribe
        // 导致modal的modelResizeEnd和MODAL的通知别的组件都接收不到了
        // PubSub.unsubscribe('modelResizeEnd');
        // PubSub.unsubscribe('MODAL');
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let type = this.props.type;
        if (nextProps.type != type) {
            let currentModal = ReactDOM.findDOMNode(this);
            let content = currentModal && currentModal.querySelector('.nc-modal');
            if (content) {
                let modalResizeWrap = content.querySelector('.modal-content-resizeWrap');
                let dialog = content.querySelector('.u-modal-dialog');
                let modalBody = content.querySelector('.u-modal-body');
                if (nextProps.type === 'max' && (modalBody || modalResizeWrap)) {
                    this.setState({
                        initModalBodyHeight: modalBody.offsetHeight,
                        modalResizeWrapHeight: modalResizeWrap && modalResizeWrap.style.height,
                        modalResizeWrapWidth: modalResizeWrap && modalResizeWrap.style.width,
                        modalResizeWrapTransform: modalResizeWrap && modalResizeWrap.style.transform,
                        dialogTop: dialog && dialog.style.top,
                    });
                    modalBody && (modalBody.style.height = document.body.offsetHeight - 32 - 40 - 44 + 'px');
                    if (modalResizeWrap) {
                        // modalResizeWrap.style.height = document.body.offsetHeight - 32 + 'px';
                        modalResizeWrap.style.height = 'auto';
                        modalResizeWrap.style.width = 'auto';
                        modalResizeWrap.style.transform = 'translate(0px, 0px)';
                    }
                    dialog && (dialog.style.top = '0');
                } else {
                    modalBody && this.state.initModalBodyHeight && (modalBody.style.height = this.state.initModalBodyHeight + 'px');
                    if (modalResizeWrap) {
                        modalResizeWrap.style.height = this.state.modalResizeWrapHeight ? this.state.modalResizeWrapHeight : 'auto';
                        modalResizeWrap.style.width = this.state.modalResizeWrapWidth ? this.state.modalResizeWrapWidth : 'auto';
                        modalResizeWrap.style.transform = this.state.modalResizeWrapTransform ? this.state.modalResizeWrapTransform : 'translate(0px, 0px)';
                    }
                    dialog && (dialog.style.top = this.state.dialogTop ? this.state.dialogTop : '0');
                    this.setState({
                        initModalBodyHeight: '',
                        modalResizeWrapHeight: '',
                        modalResizeWrapWidth: '',
                        modalResizeWrapTransform: '',
                        dialogTop: '',
                    });
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { type } = this.props;
        if ((prevProps.type === 'max' && type !== 'max') || (prevProps.type !== 'max' && type === 'max')) {
            let currentModal = ReactDOM.findDOMNode(this);
            let { onResizeStop, indexInfo, className, id } = this.props;
            onResizeStop && onResizeStop();
            PubSub.publish('modelResizeEnd', { indexInfo, className, id });
            PubSub.publish('MODAL', { sence: 'modal', currentModal });
        }

    }

    changeZIndex = (el, zIndex) => {
        el.style.setProperty('z-index', zIndex);
        let modalBackDrop = el.previousSibling;
        modalBackDrop && modalBackDrop.style.setProperty('z-index', zIndex - 1);
    };

    //从类名获取当前的modal的是否是大中小自适应类型的弹框
    getCustomType = (className, type) => {
        if (className) {
            if (className.indexOf('junior') !== -1) {
                return 'junior';
            } else if (className.indexOf('senior') !== -1) {
                return 'senior';
            } else if (className.indexOf('combine') !== -1) {
                return 'combine';
            } else if (className.indexOf('prompt-box') !== -1) {
                return 'prompt-box';
            } else if (className.indexOf('createNcModal') !== -1) {
                return 'createNcModal';
            } else if (className.indexOf('bill-track') !== -1) {
                return 'bill-track';
            } else if (className.indexOf('FormulaEditorWrap') !== -1) {
                return 'formula';
            }
        } else if (type) { // 推荐领域使用type
            if (typeMap[type]) {

                return type;
            }
        }
        return '';
    };

    //处理宽高有显示的类型的modal
    getMinHW = type => {
        let info = {};
        if (
            type === 'junior' ||
            type === 'prompt-box' ||
            type === 'createNcModal'
        ) {
            info.height = 201;
            info.width = 410;
        } else if (type === 'senior') {
            info.height = 256;
            info.width = 520;
        } else if (type === 'combine') {
            info.height = 302;
            info.width = 680;
        }
        return info;
    };

    onEscapeKeyUp = () => {
        // esc的時候先關閉  toast提示和日期面板  然後再執行彈窗的關閉事件  by bbqin
        // 获取所有日期面板dom 并转化为数组
        const datePanels = Array.prototype.slice.call(document.querySelectorAll('.nc-date-picker-dropdown'), 0);
        // 只要有一个日期面板未关闭 则 hasDatePanel为true
        const hasDatePanel = datePanels.length > 0 && datePanels.some(panel => getComputedStyle(panel).getPropertyValue('display') === 'block');
        this.escKeyed = !!(
            document && (document.querySelector('.toast-zijinyun-project') || hasDatePanel)
        );
        this.props.onEscapeKeyUp && this.props.onEscapeKeyUp();
    };

    onHide = () => {
        const datePanels = Array.prototype.slice.call(document.querySelectorAll('.nc-date-picker-dropdown'), 0);
        const hasDatePanel = datePanels.length && datePanels.some(panel => getComputedStyle(panel).getPropertyValue('display') === 'block');
        let canClose = !(
            document && (document.querySelector('.toast-zijinyun-project') || hasDatePanel)
        );
        // console.log('escKeyed', this.escKeyed, 'canClose', canClose);
        // 由於要兼容  點擊x和esc兩種情況  所有是 ！==true
        (this.escKeyed !== true || canClose) && this.props.onHide && this.props.onHide();
    };

    /**
     * 判断当前的modal是不是顶层的modal  by bbqin
     */
    isTopModal = () => {
        let referModal = document.querySelector('.refer-pop-window.disabled-bg-btn');

        if (referModal) {
            return false;
        }

        if (this.modal) {
            let modals = this.modal.props.manager.modals;
            return (
                ReactDOM.findDOMNode(this.modal) ===
                ReactDOM.findDOMNode(modals[modals.length - 1])
            );
        }
        return false;
    };

    /**
     * 弹窗完成显示添加自动聚焦焦点的操作
     * @param {*} modalDom
     */
    onEnteredHandle(modalDom) {
        let { modalAutoFocus = true } = this.props;
        let content = modalDom.querySelector('.u-modal-content');
        if (content && modalAutoFocus) {
            let modalBody = content.querySelector('.u-modal-body');
            if (modalBody) {
                modalBody.tabIndex = '0';
                modalBody.focus();
            } else {
                content.tabIndex = '0';
                content.focus();
            }
        }
        setTimeout(()=>{
            this.props.onEntered && this.props.onEntered(modalDom);
        }, 200)
    }

    /**
     * 显示开始
     */
    onEnterHandle(modalDom) {
        // 解决表格内焦点回执的问题  暂时方案 TODO
        // this.prevActiveElement = null;
        modalDom.id = this.props.id
        this.prevActiveElement = document.activeElement;

        let { className, resizable, bodyHeight, size, max, type } = this.props;
        let content = modalDom.querySelector('.u-modal-content');
        if (content) {
            let modalBody = content.querySelector('.u-modal-body');
            let customType = this.getCustomType(className, type);
            if (modalBody) {
                //给王印（孙泽光部门）加可以设置模态框高度属性
                if (bodyHeight) {
                    modalBody.style.height = bodyHeight;
                } else if (customType) {
                    if (customType === 'bill-track') {
                        modalBody.style.maxHeight =
                            document.body.offsetHeight - 40 - 60 + 'px';
                    } else {
                        modalBody.classList &&
                            modalBody.classList.add(
                                `u-modal-${customType}-body`,
                            );
                    }
                } else if (size == 'max' || type == 'max') {
                    modalBody.style.height = document.body.offsetHeight - 32 - 40 - 44 + 'px';

                } else {
                    //给非定制类型的modal设置最大高度 可视区高度减去nc-modal的padding、u-modal-body的padding、
                    //modalHeader的高度、modalFooter的高度  上下margin的高度
                    modalBody.style.maxHeight =
                        document.body.offsetHeight - 32 - 40 - 44 + 'px';
                    // document.body.offsetHeight - 32 - 40 - 44 - 60 + 'px';  // 为了可以最大化 这里不能这样写
                }
            }
            try {
                if (resizable !== false) {
                    content.parentElement.parentElement.classList.add(
                        'modal-content-resizeWrap-parent',
                    );
                } else {
                    content.parentElement.classList.add(
                        'modal-content-parent',
                    );
                }
            } catch (err) { console.log(err); }
        }
        this.props.onEnter && this.props.onEnter();
    }

    /**
     * 隐藏结束
     */
    onExitedHandle() {
        let { focusBody = true } = this.props;
        if ((!this.prevActiveElement || !this.prevActiveElement.parentElement) && focusBody) {
            // 如果父级不存在 说明消失了 焦点到body上
            document && document.body.focus();
        }
        this.props.onExited && this.props.onExited();
    }

    /**
     * resize结束时的回调
     * 处理大中小三种类型弹框配置拖拽之后的出现的问题
     */
    // 三个参数 e, dir, elementRef
    onResizeStopHandle = () => {
        let currentModal = ReactDOM.findDOMNode(this);
        let { onResizeStop, indexInfo, className, id } = this.props;
        onResizeStop && onResizeStop();
        PubSub.publish('modelResizeEnd', { indexInfo, className, id });
        PubSub.publish('MODAL', { sence: 'modal', currentModal });
    };

    /**
      * resize开始时的回调
      * 去掉大中小三种类型弹框配置的最大，最大宽度
      */
    onResizeStartHandle = () => {
        let { className, type } = this.props;
        let currentModal = ReactDOM.findDOMNode(this);
        if (currentModal) {
            let modalBody = currentModal.querySelector('.u-modal-body');
            if (modalBody) {
                let customType = this.getCustomType(className, type);
                modalBody.style.height = modalBody.offsetHeight + 'px';
                modalBody.style.maxHeight = 'none'; // 去除一下最大高度 避免出现问题
                modalBody.classList.remove(`u-modal-${customType}-body`);
            }
        }
    }

    /**
     * 多个modal显示的层级管理
     * ModalArr在body下ModalArr组成的数组
     */
    modalIndexManager = ModalArr => {
        Array.from(ModalArr).forEach((el, index) => {
            for (let attr in indexArr) {
                if (el.classList.contains(attr)) {
                    let newIndex = index;
                    if (
                        (el.classList.contains('prompt-box') ||
                            el.classList.contains('createNcModal')) &&
                        Number(indexArr[attr]) === 200
                    ) {
                        newIndex = Number(index) + 131;//231改成131,如果有问题再让陈道诚改 NCC-75445这个问题
                    }
                    let zIndex = Number(indexArr[attr]) + Number(newIndex) + 2;
                    this.changeZIndex(ModalArr[index], zIndex);
                    // }
                }
            }
        });
    };

    render() {
        let {
            className,
            backdropStyle,
            indexInfo,
            zIndex = 200,
            onEscapeKeyUp,
            onHide,
            onExited,
            onEnter,
            onEntered,
            fieldid,
            draggable,
            resizable,
            backdrop,
            id,
            max,
            //size,
            type = '',
            ...others
        } = this.props;
        if (id && indexInfo) {
            indexArr[indexInfo.id] = indexInfo.zIndex;
        } else {
            id = this.props.id ? this.props.id : Date.now() + getSafeRandom();
            indexArr[id] = zIndex;
        }
        if (this.props.size === "max") {
            className = `${className} max`;
        }
        let customType = this.getCustomType(className, type);
        let customSizeInfo = this.getMinHW(customType);

        this.timer = setTimeout(() => {
            //多个模态框叠加显示的层级处理
            let ModalArr = document.getElementsByClassName('nc-modal');
            let ModalInTop = getTopWindow().document.getElementsByClassName('nc-modal');
            this.modalIndexManager(ModalArr, id);
            this.modalIndexManager(ModalInTop, id);
        });

        if (fieldid) {
            fieldid = fieldid + '_modal-area';
        }
        if (!fieldid) {
            fieldid = '_modal-area';
        }

        fieldid = getSysFieldid(fieldid);

        //不配置backdrop为true或者false的，默认都是点击遮罩禁止关闭
        if (!backdrop && backdrop !== false) {
            backdrop = 'static';
        }
        let { noFooter } = this.props;

        return (
            <OriginModal
                fieldid={fieldid}
                enforceFocus={false}
                atuoFocus={false}
                className={
                    classnames(`${id}`,
                        'nc-modal',
                        'disabled-bg-btn',
                        `${className}`,
                        {
                            'no-footer': noFooter,
                            [type]: type && typeMap[type],
                            'resizable-modal': resizable === undefined ? true : resizable,
                        },
                    )
                }
                backdropStyle={{ ...backdropStyle }}
                backdrop={backdrop}
                ref={modal => (this.modal = modal)}
                onEntered={this.onEnteredHandle.bind(this)}
                onEnter={this.onEnterHandle.bind(this)}
                // onEntering={this.onEnteringHandle}
                onExited={this.onExitedHandle.bind(this)}
                onResizeStop={this.onResizeStopHandle}
                onResizeStart={this.onResizeStartHandle}
                keyboard={true}
                onEscapeKeyUp={this.onEscapeKeyUp.bind(this)}
                onHide={this.onHide.bind(this)}
                width={customSizeInfo.width}
                draggable={draggable === undefined ? true : draggable}
                resizable={resizable === undefined ? true : resizable}
                resizeClassName='modal-content-resizeWrap'
                minHeight={customSizeInfo.height ? customSizeInfo.height : undefined}
                minWidth={customSizeInfo.width ? customSizeInfo.width : undefined}
                centered={true} //会造成拖拽之后立马回到原来位置的问题
                {...others}
                bounds='html'
            />
        );
    }
}

class Header extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, closeButton, showMaxButton, headerRight, max, maxButtonClick, ...others } = this.props;
        let closeButtonProps = {};
        if (closeButton) {
            closeButtonProps.fieldid = 'close_btn';
        }

        if (!fieldid) {
            fieldid = 'header-area';
        }
        fieldid = getSysFieldid(fieldid);
        return (
            <OriginModal.Header fieldid={fieldid} closeButtonProps={closeButtonProps} closeButton={closeButton} {...others} ref="modalHeader">
                <img
                    className="modal-header-img"
                    //src='../../static/images/modal-img.png'
                    src={require('../../static/images/modal-img.png')}
                />
                {this.props.children}
                <div className="modal-header-right dnd-cancel" >
                    {headerRight ? headerRight() : ''}
                    {showMaxButton ? <MaxZoomBtn max={max} onClick={(max, e) => {
                        e.preventDefault();
                        maxButtonClick && maxButtonClick(max, e);
                    }} /> : ''}
                </div>
            </OriginModal.Header>
        );
    }
}

class Title extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;

        //传了fieldid使用传的内容做标记
        if (fieldid) {
            fieldid = fieldid + '_title';
        } else {
            // 业务组未传fieldid的,使用children作为标记
            fieldid =
                typeof this.props.children === 'string'
                    ? `${this.props.children}_title`
                    : '_title';
        }
        fieldid = getSysFieldid(fieldid);

        return (
            <OriginModal.Title {...others} fieldid={fieldid}>
                {this.props.children}
            </OriginModal.Title>
        );
    }
}

class Body extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <OriginModal.Body {...this.props}>
                {this.props.children}
            </OriginModal.Body>
        );
    }
}

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;
        if (!fieldid) {
            fieldid = 'bottom-area';
        }
        fieldid = getSysFieldid(fieldid);
        return <OriginModal.Footer {...others} fieldid={fieldid} />;
    }
}

Modal.Header = Header;
Modal.Title = Title;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;

// Modal.Header = Modal.Header;
// Modal.Title = Modal.Title;
// Modal.Body = Modal.Body;
// Modal.Footer = Modal.Footer;
